export default {
  hello: 'Witaj',
  common: {
    yes: 'Tak',
    no: 'Nie',
    ok: 'OK',
    notAvailable: 'Niedostępny',
    cancel: 'Anuluj',
    saving: 'Zapisywanie...',
    showMore: 'Pokaż więcej',
    showLess: 'Pokaż mniej',
    back: 'Wstecz',
    advertisement: 'Reklama',
    learnMore: 'Dowiedz się więcej'
  },
  offers: 'Ogłoszenia pojazdów',
  addOffer: 'Dodaj ogłoszenie',
  login: 'Logowanie',
  register: {
    title: 'Rejestracja',
    subtitle: 'Utwórz nowe konto',
    email: 'Email',
    password: 'Hasło',
    confirmPassword: 'Potwierdź hasło',
    terms: 'Akceptuję regulamin',
    termsLink: 'regulamin',
    register: 'Zarejestruj się',
    login: 'Masz już konto? Zaloguj się',
    successTitle: 'Rejestracja udana',
    successMsg: 'Na Twój adres email został wysłany link weryfikacyjny. Sprawdź swoją skrzynkę.',
    errorTitle: 'Błąd rejestracji',
    errorMsg: 'Wystąpił błąd podczas rejestracji. Spróbuj ponownie.',
    passwordMismatch: 'Hasła nie są identyczne',
    termsRequired: 'Musisz zaakceptować regulamin',
    emailRequired: 'Email jest wymagany',
    emailInvalid: 'Nieprawidłowy format email',
    passwordRequired: 'Hasło jest wymagane',
    passwordMinLength: 'Hasło musi mieć minimum 8 znaków',
    passwordPattern: 'Hasło musi zawierać co najmniej jedną wielką literę, jedną małą literę i jedną cyfrę'
  },
  home: {
    title: 'Giełda4x4',
    subtitle: 'Największy portal ogłoszeń pojazdów z napędem na cztery koła w Polsce',
    browseOffers: 'Przeglądaj ogłoszenia',
    addOffer: 'Dodaj ogłoszenie',
    login: 'Zaloguj się',
    register: 'Zarejestruj się',
    whyChooseUs: 'Dlaczego warto wybrać nas?',
    verifiedOffers: 'Weryfikowane ogłoszenia',
    verifiedOffersDesc: 'Każde ogłoszenie jest sprawdzane przez nasz zespół ekspertów',
    fastSale: 'Szybka sprzedaż',
    fastSaleDesc: 'Dotrzyj do tysięcy potencjalnych kupujących w całej Polsce',
    support: 'Wsparcie 24/7',
    supportDesc: 'Nasz zespół jest zawsze gotowy do pomocy',
    popularCategories: 'Popularne kategorie',
    suv: 'SUV',
    pickup: 'Pick-up',
    terrain: 'Terrain',
    truck: 'Ciężarowe',
    carDatabase: 'Baza samochodów',
    searchPlaceholder: 'Czego szukasz?',
    category: 'Kategoria',
    brand: 'Marka',
    model: 'Model',
    otherBrand: 'Marka pojazdu',
    otherModel: 'Model pojazdu',
    allModels: 'Wszystkie modele',
    allBrands: 'Wszystkie marki',
    yearFrom: 'Rok od',
    yearTo: 'Rok do',
    priceFrom: 'Cena od',
    priceTo: 'Cena do',
    categories: 'Popularne Kategorie',
    featured: 'Wyróżnione',
    featuredOffers: 'Wyróżnione Ogłoszenia',
    latest: 'Ostatnio dodane',
    latestCars: 'Ostatnio dodane samochody',
    latestQuads: 'Ostatnio dodane quady',
    terenowe: 'Terenowe',
    'pick-up': 'Pick-up',
    van: 'Van',
    ciężarowe: 'Ciężarowe',
    utv: 'UTV',
    popularBrands: 'Popularne marki',
    offersCount: 'liczba ogłoszeń',
    viewAllOffers: 'Zobacz wszystkie ogłoszenia',
    viewMore: 'Zobacz więcej',
    topBrands: 'NAJPOPULARNIEJSZE MARKI',
    viewAllInCategory: 'Zobacz więcej',
    // Nowe teksty ze strony głównej
    heroTitle: 'Portal ogłoszeń nowej generacji',
    heroSubtitle: 'Wystawiaj szybciej niż kiedykolwiek. Wypełnij ogłoszenie na podstawie zdjęcia.',
    addOfferWithAI: 'Dodaj Ogłoszenie za darmo',
    addOfferWithAIMobile: 'Dodaj za darmo',
    whyUs: 'Dlaczego My?',
    whyUsSubtitle: 'Odkryj korzyści, które wyróżniają naszą platformę',
    aiAutomation: 'Automatyzacja AI',
    aiAutomationDesc: 'Dodaj ogłoszenie w 60 sekund. Zrób zdjęcie, a my zajmiemy się resztą. Nasza sztuczna inteligencja automatycznie wypełni wszystkie szczegóły.',
    communityPassion: 'Społeczność Pasjonatów',
    communityPassionDesc: 'Twoja oferta trafi prosto do znawców tematu, bez przypadkowych osób. Sprzedawaj wśród prawdziwych entuzjastów off-roadu.',
    alwaysFree: 'Za Darmo',
    alwaysFreeDesc: 'Wszystkie ogłoszenia są darmowe. Bez ukrytych kosztów, bez abonamentów.',
    bestOffers: 'Wybrane Ogłoszenia',
    viewAllOffersButton: 'Zobacz Wszystkie Ogłoszenia',
    popularBrandsSubtitle: 'Odkryj oferty najpopularniejszych marek',
    viewAllBrands: 'Zobacz wszystkie marki',
    // Sekcja SEO
    seoTitle: 'Giełda4x4.pl - Największa Platforma Sprzedaży Pojazdów 4x4 oraz akcesoriów w Polsce',
    seoDescription1: 'Giełda4x4.pl to wiodąca w Polsce platforma internetowa dedykowana pasjonatom pojazdów terenowych, off-road i sportów ekstremalnych. Łączymy miłośników samochodów terenowych, quadów, UTV i sprzętu off-road z całej Polski wspierając nowoczesne narzędzia i rozwiązania sztucznej inteligencji.',
    seoDescription2: 'Nasza giełda specjalizuje się w ogłoszeniach samochodów terenowych, SUV-ów, pick-upów, vanów, ciężarówek, UTV, quadów oraz szerokiej gamy części samochodowych, akcesoriów off-road, opon terenowych i felg off-road. Obsługujemy wszystkie popularne marki',
    seoDescription3: 'Oferujemy ogłoszenia usług dla branży off-road: serwis, modyfikacje, sprzedaż pojazdów terenowych, części do samochodów 4x4, akcesoria terenowe, opony off-road, felgi terenowe, sprzęt do jazdy terenowej, narzędzia, torby, namioty, kuchenki.',
    seoDescription4: 'Nasza platforma wykorzystuje najnowsze technologie, w tym sztuczną inteligencję do automatycznego wypełniania ogłoszeń, weryfikację użytkowników i wsparcie techniczne. Wszystkie ogłoszenia dla użytkowników prywatnych są całkowicie darmowe, bez ukrytych kosztów i abonamentów.',
    seoDescription5: 'Giełda4x4.pl to miejsce, gdzie spotykają się prawdziwi pasjonaci off-road, miłośnicy jazdy terenowej, sportów ekstremalnych, wypraw 4x4, rajdów terenowych, off-road, mudding, rock crawling, overlanding, car camping, survival, bushcraft, hiking, trekking, climbing, mountaineering, backpacking, wilderness, adventure, expedition, exploration, discovery, journey, travel, trip, vacation, holiday, break, escape, retreat, getaway i outdoor activities.',
    // Karuzela "Kim jesteśmy"
    aboutUsTitle: 'Kim jesteśmy',
    aboutUsSubtitle: 'Poznaj naszą historię i misję w świecie pojazdów terenowych',
    aboutUsCard1Title: 'Giełda 4x4',
    aboutUsCard2Title: 'Nasza Specjalizacja',
    aboutUsCard3Title: 'Nasze Usługi',
    aboutUsCard4Title: 'Nowoczesne Technologie',
    aboutUsCard5Title: 'Społeczność Pasjonatów'
  },
  loginPage: {
    title: 'Logowanie',
    email: 'E-mail',
    password: 'Hasło',
    loginBtn: 'Zaloguj się',
    noAccount: 'Nie masz konta?',
    register: 'Zarejestruj się',
    loading: 'Logowanie...',
    success: 'Zalogowano pomyślnie. Przekierowanie na stronę główną...',
    error: 'Błąd logowania',
    goHome: 'Przejdź na stronę główną',
    close: 'Zamknij',
    privacyPolicy: 'Polityka prywatności',
    termsOfService: 'Regulamin',
    forgotPassword: 'Nie pamiętasz hasła?',
    rememberMe: 'Zapamiętaj mnie'
  },
  offersPage: {
    title: 'Ogłoszenia',
    loading: 'Ładowanie ogłoszeń...',
    noOffers: 'Brak ogłoszeń do wyświetlenia.',
    search: 'Szukaj...',
    mainCategory: 'Kategoria główna',
    allBrands: 'Wszystkie marki',
    allModels: 'Wszystkie modele',
    brand: 'Marka',
    model: 'Model',
    otherBrand: 'Marka Pojazdu',
    otherModel: 'Model Pojazdu',
    priceRange: 'Cena',
    yearRange: 'Rok produkcji',
    mileageRange: 'Przebieg',
    engineCapacityRange: 'Pojemność silnika (cm³)',
    enginePowerRange: 'Moc silnika (KM)',
    location: 'Lokalizacja',
    locationPlaceholder: 'Wpisz miasto lub adres...',
    distance: 'Odległość',
    distancePlaceholder: 'Maksymalna odległość',
    subcategory: 'Kategoria',
    subSubcategory: 'Podkategoria',
    selectSubcategory: 'Wybierz kategorię',
    selectSubSubcategory: 'Wybierz podkategorię',
    activeFilters: 'Aktywne filtry',
    clearAll: 'Wyczyść wszystkie',
    sortByDefault: 'Domyślne',
    sortByNewest: 'Od najnowszych',
    filters: 'Filtry',
    clearFilters: 'Wyczyść filtry',
    sortBy: 'Sortuj według',
    newest: 'Najnowsze',
    oldest: 'Najstarsze',
    priceAsc: 'Cena: od najniższej',
    priceDesc: 'Cena: od najwyższej',
    mileageAsc: 'Przebieg: od najniższego',
    mileageDesc: 'Przebieg: od najwyższego',
    yearAsc: 'Rok: od najstarszego',
    yearDesc: 'Rok: od najnowszego',
    foundOffers: 'Znaleziono {count} ogłoszeń',
    seeDetails: 'Zobacz',
    prev: 'Poprzednia',
    next: 'Następna',
    added: 'Dodano',
    views: 'Wyświetlenia',
    back: 'Powrót do ogłoszeń',
    min: 'Min',
    max: 'Max',
    advancedSearch: 'Wyszukiwanie zaawansowane',
    any: 'Dowolne',
    yes: 'Tak',
    searchButton: 'Szukaj',
    showMore: 'Pokaż więcej',
    showLess: 'Pokaż mniej',
    searchBrand: 'Szukaj marki...',
    gridView: 'Widok siatki',
    listView: 'Widok listy',
    mapView: 'Widok mapy',
    saveSearch: 'Zapisz wyszukiwanie',
    honorBadge: 'Wyróżnione',
    searchFields: 'Pola wyszukiwania',
    selectOption: 'Wybierz opcję',
    enterValue: 'Wprowadź wartość',
    details: {
      loading: 'Ładowanie szczegółów ogłoszenia...',
      notFound: 'Ogłoszenie nie zostało znalezione.',
      back: 'Powrót do ogłoszeń',
      year: 'Rok produkcji',
      mileage: 'Przebieg',
      registrationNumber: 'Numer rejestracyjny',
      firstRegistrationDate: 'Data pierwszej rejestracji',
      vin: 'VIN',
      engineCapacity: 'Pojemność silnika',
      enginePower: 'Moc silnika',
      description: 'Opis',
      vehicleSpecification: 'Specyfikacja pojazdu',
      attributes: 'Atrybuty ogłoszenia',
      otherAttributes: 'Inne atrybuty',
      category: 'Kategoria',
      contactInfo: 'Informacje kontaktowe',
      seller: 'Sprzedawca',
      showPhone: 'Pokaż numer telefonu',
      hidePhone: 'Ukryj numer telefonu',
      phoneNumber: 'Numer telefonu',
      viewSellerProfile: 'Zobacz profil sprzedającego',
      reportUser: 'Zgłoś użytkownika',
      reportEmailSubject: 'Zgłoszenie użytkownika - {userName} - {offerName}',
      reportEmailBody: `Zgłoszenie użytkownika

Dane zgłoszenia:
- Użytkownik: {userName}
- Ogłoszenie: {offerName}
- Link do ogłoszenia: {offerUrl}

Powód zgłoszenia:
[Proszę opisać powód zgłoszenia]

Dodatkowe informacje:
[Proszę podać dodatkowe informacje, jeśli są dostępne]

---
To zgłoszenie zostało wysłane z formularza na stronie Giełda4x4.`,
      showOnMap: 'Pokaż na mapie',
      location: 'Lokalizacja',
      offerInactive: 'To ogłoszenie nie jest już aktywne',
      backToOffers: 'Powrót do ogłoszeń',
      brand: 'Marka',
      model: 'Model',
      similarOffers: 'Podobne ogłoszenia',
      loadingSimilarOffers: 'Ładowanie podobnych ogłoszeń...',
      showVin: 'Pokaż VIN',
      checkVehicleHistory: 'Sprawdź historię pojazdu',
      readMore: 'Czytaj więcej',
      andMore: 'i {count} więcej',
      vehicleCategories: 'Dedykowane do',
      dedicatedToModel: 'Dedykowane do Modelu',
      dedicatedToBrand: 'Dedykowane do Marki',
      learnMoreTitle: 'Dowiedz się więcej o słabych i mocnych stronach tego modelu',
      viewModelInfo: 'Zobacz informacje o {brand} {model}',
      partnerHonor: 'Wyróżnienie Partnera',
      partnerHonorBadge: 'Wyróżnione dzięki'
    },
    pagination: {
      ellipsis: '...',
      firstPage: 'Pierwsza strona',
      lastPage: 'Ostatnia strona',
      page: 'Strona {page}',
      of: 'z',
      previous: 'Poprzednia',
      next: 'Następna'
    },
    tabs: 'Zakładki',
    // Meta tags translations
    defaultTitle: 'Portal ogłoszeń pojazdów z napędem na cztery koła',
    offersTitle: 'Ogłoszenia',
    defaultDescription: 'Najlepsze miejsce do kupna i sprzedaży pojazdów terenowych w Polsce',
    brandDescription: 'Kup lub sprzedaj samochód marki {brand}. Sprawdź aktualne ogłoszenia {brand} na Giełda4x4 · najlepszym portalu ogłoszeń pojazdów z napędem na cztery koła.',
    brandModelDescription: 'Kup lub sprzedaj {brand} {model}. Sprawdź aktualne ogłoszenia {brand} {model} na Giełda4x4 · najlepszym portalu ogłoszeń pojazdów z napędem na cztery koła.',
    brandModelsDescription: 'Kup lub sprzedaj {brand} {models}. Sprawdź aktualne ogłoszenia {brand} na Giełda4x4 · najlepszym portalu ogłoszeń pojazdów z napędem na cztery koła.',
  },
  locationMap: {
    showNearbyOffers: 'Pokaż pobliskie ogłoszenia',
    loadingOffers: 'Wczytywanie pobliskich ogłoszeń...',
    offersInRadius: 'ogłoszeń w promieniu {radius}km',
    offersInThisLocation: 'Ogłoszenia w tej lokalizacji',
    offersFound: '{count} ogłoszeń znalezionych',
    noTitle: 'Brak tytułu',
    noBrand: 'Brak marki',
    noModel: 'Brak modelu',
    noAddress: 'Brak adresu',
    priceToAgree: 'Cena do uzgodnienia',
    viewDetails: 'Zobacz szczegóły',
    invalidCoordinates: 'Nieprawidłowe współrzędne lokalizacji',
    invalidSearchParams: 'Nieprawidłowe parametry wyszukiwania',
    serverError: 'Błąd serwera podczas wyszukiwania',
    networkError: 'Błąd połączenia z serwerem',
    searchError: 'Wystąpił błąd podczas wyszukiwania pobliskich ofert'
  },
  // Meta tags translations for pages that don't use offersPage structure
  metaTags: {
    wiki: {
      title: 'Wiki - Modele pojazdów z napędem 4x4 · Giełda4x4',
      description: 'Szczegółowe informacje o modelach pojazdów terenowych. Poznaj specyfikacje, charakterystyki i historię marek 4x4.',
      keywords: 'wiki, baza wiedzy, modele samochodów, pojazdy terenowe, 4x4, suv, pick-up, specyfikacje'
    },
    faq: {
      title: 'FAQ - Często zadawane pytania · Giełda4x4',
      description: 'Odpowiedzi na najczęściej zadawane pytania o Giełda4x4. Dowiedz się jak korzystać z portalu ogłoszeń pojazdów terenowych.',
      keywords: 'faq, pytania, gielda4x4, pomoc, często zadawane pytania, pojazdy terenowe'
    },
    privacyPolicy: {
      title: 'Polityka Prywatności · Giełda4x4',
      description: 'Polityka prywatności Giełda4x4. Dowiedz się jak chronimy Twoje dane osobowe w naszym portalu ogłoszeń pojazdów terenowych.',
      keywords: 'polityka prywatności, gielda4x4, rodo, ochrona danych, dane osobowe'
    },
    termsOfService: {
      title: 'Regulamin · Giełda4x4',
      description: 'Regulamin korzystania z Giełda4x4. Zapoznaj się z zasadami korzystania z naszego portalu ogłoszeń pojazdów terenowych.',
      keywords: 'regulamin, gielda4x4, warunki użytkowania, zasady, portal ogłoszeń'
    },
    comparison: {
      title: 'Porównanie ofert · Giełda4x4',
      description: 'Porównaj oferty pojazdów terenowych. Sprawdź specyfikacje, ceny i parametry różnych modeli 4x4 w jednym miejscu.',
      keywords: 'porównanie ofert, pojazdy terenowe, 4x4, suv, pick-up, porównanie samochodów'
    },
    notFound: {
      title: 'Strona nie została znaleziona · Giełda4x4',
      description: 'Przepraszamy, strona której szukasz nie istnieje. Sprawdź nasze ogłoszenia pojazdów terenowych.',
      keywords: '404, strona nie istnieje, gielda4x4, pojazdy terenowe'
    },
    about: {
      title: 'O nas · Giełda4x4',
      description: 'Poznaj historię Giełdy4x4 - największego portalu ogłoszeń pojazdów z napędem na cztery koła w Polsce',
      keywords: 'o nas, gielda4x4, pojazdy terenowe, misja, 4x4, portal ogłoszeń'
    }
  },
  accessibility: {
    toggleMobileMenu: 'Przełącz menu mobilne',
    scrollLeft: 'Przewiń w lewo',
    scrollRight: 'Przewiń w prawo',
    tabs: 'Zakładki',
    facebook: 'Facebook',
    instagram: 'Instagram'
  },
  comparison: {
    title: 'Porównanie ogłoszeń',
    noOffers: 'Brak ogłoszeń do porównania',
    noOffersDescription: 'Dodaj ogłoszenia do porównania, aby zobaczyć je obok siebie',
    needMoreOffers: 'Potrzebujesz więcej ogłoszeń',
    needMoreOffersDescription: 'Dodaj co najmniej 2 ogłoszenia, aby rozpocząć porównanie',
    browseOffers: 'Przeglądaj ogłoszenia',
    clearAll: 'Wyczyść wszystko',
    confirmClear: 'Czy na pewno chcesz wyczyścić wszystkie ogłoszenia z porównania?',
    removeFromComparison: 'Usuń z porównania',
    brand: 'Marka',
    model: 'Model',
    year: 'Rok',
    mileage: 'Przebieg',
    engineCapacity: 'Pojemność silnika',
    enginePower: 'Moc silnika',
    bodyType: 'Typ nadwozia',
    driveType: 'Napęd',
    location: 'Lokalizacja',
    attributes: 'Atrybuty',
    specifications: 'Specyfikacje',
    offers: 'Ogłoszenia',
    comparing: 'Porównujesz',
    maxReached: 'Maksymalna liczba ogłoszeń',
    viewComparison: 'Zobacz porównanie'
  },
  comparisonButton: {
    addToComparison: 'Dodaj do porównania',
    removeFromComparison: 'Usuń z porównania',
    comparisonFull: 'Porównanie pełne (maks. 4 ogłoszenia)',
    loading: 'Ładowanie...',
    addedToComparison: 'Dodano do porównania',
    removedFromComparison: 'Usunięto z porównania',
    error: 'Wystąpił błąd',
    errorFetchingOffer: 'Błąd podczas pobierania danych ogłoszenia'
  },
  addOfferPage: {
    title: 'Dodaj ogłoszenie',
    editTitle: 'Edytuj ogłoszenie',
    description: 'Dodaj nowe ogłoszenie pojazdu terenowego na Giełda4x4. Wypełnij szczegółowe informacje o swoim pojeździe, dodaj zdjęcia i dotrzyj do tysięcy potencjalnych kupujących.',
    step1: 'Krok 1: Podstawowe dane',
    step2: 'Krok 2: Wyposażenie i atrybuty',
    step3: 'Krok 3: Zdjęcia',
    step3Description: 'Dodaj zdjęcia swojego pojazdu. Możesz dodać maksymalnie 10 zdjęć.',
    next: 'Dalej',
    prev: 'Wstecz',
    submit: 'Dodaj',
    submitting: 'Dodawanie...',
    successTitle: 'Ogłoszenie zostało dodane.',
    successMsg: 'Twoja ogłoszenie zostało pomyślnie zapisana.',
    addAnother: 'Dodaj kolejną',
    view: 'Zobacz ogłoszenie',
    errorTitle: 'Błąd',
    close: 'Zamknij',
    photos: 'Zdjęcia',
    uploadingPhotos: 'Wgrywanie zdjęć',
    pleaseWait: 'Proszę czekać',
    basicInfo: 'Podstawowe informacje',
    specifications: 'Specyfikacja i atrybuty',
    carSpecificationRequired: 'Wybór specyfikacji pojazdu jest wymagany',
    requiredAttributesMissing: 'Brakujące wymagane atrybuty: {attributes}',
    checkTab: 'Sprawdź zakładkę: {tab}',
    required: 'Wymagane',
    cityRequired: 'Miasto jest wymagane',
    vinRequired: 'Numer VIN jest wymagany dla samochodów',
    subcategoryRequired: 'Wybór podkategorii jest wymagany',
    subSubcategoryRequired: 'Wybór pod-podkategorii jest wymagany',
    requiredSearchFieldsMissing: 'Brakujące wymagane pola: {fields}',
    attributes: 'Atrybuty',
    applySpecificationAttributes: 'Zastosuj atrybuty specyfikacji',
    applySpecificationAttributesHelp: 'Kliknij przycisk "Zastosuj", aby automatycznie wypełnić atrybuty zgodnie z wybraną specyfikacją. Możesz je później zmienić.',
    applyButton: 'Zastosuj',
    form: {
      title: 'Tytuł ogłoszenia',
      description: 'Opis',
      price: 'Cena',
      currency: 'Waluta',
      year: 'Rok produkcji',
      mileage: 'Przebieg',
      mileageUnit: 'Jednostka przebiegu',
      category: 'Kategoria',
      city: 'Miasto',
      region: 'Region',
      district: 'Dzielnica',
      street: 'Ulica',
      coordinates: 'Współrzędne',
      registrationNumber: "Numer rejestracyjny",
      firstRegistrationDate: "Data pierwszej rejestracji",
      vin: "VIN",
      engineCapacity: "Pojemność silnika (cm³)",
      enginePower: "Moc silnika (KM)",
      attributes: "Atrybuty",
      required: "wymagane",
      submit: "Dodaj ogłoszenie",
      subcategory: "Kategoria",
      selectSubcategory: "Wybierz kategorię",
      subSubcategory: "Podkategoria",
      selectSubSubcategory: "Wybierz podkategorię",
      searchFields: "Pola wyszukiwania",
      selectOption: "Wybierz opcję",
      brandModelInfo: "Wybierz markę i model, jeśli Twoje ogłoszenie dotyczy części, akcesoriów lub usług dla konkretnej marki lub modelu pojazdu."
    },
    tooltips: {
      submitting: 'Trwa dodawanie ogłoszenia...',
      uploading: 'Trwa wgrywanie zdjęć...',
      noImages: 'Dodaj co najmniej jedno zdjęcie, aby kontynuować',
      autoCompleteAlreadyUsed: 'Funkcja auto-uzupełniania została już użyta dla tego ogłoszenia',
      autoCompleteUploading: 'Poczekaj na zakończenie wgrywania zdjęć',
      autoCompleteNoImages: 'Dodaj co najmniej jedno zdjęcie, aby użyć auto-uzupełniania',
      autoCompleteReady: 'Kliknij, aby automatycznie wypełnić dane na podstawie zdjęć'
    },
    autoCompleteTitle: 'Auto-uzupełnianie danych',
    autoCompleteDescription: 'Użyj sztucznej inteligencji, aby automatycznie wypełnić dane ogłoszenia na podstawie przesłanych zdjęć. Funkcja analizuje zdjęcia i sugeruje markę, model, rok produkcji i inne szczegóły.',
    autoCompleteDescriptionVehicle: 'Użyj sztucznej inteligencji, aby automatycznie wypełnić dane ogłoszenia na podstawie przesłanych zdjęć. Funkcja analizuje zdjęcia i sugeruje markę, model, rok produkcji i inne szczegóły.',
    autoCompleteDescriptionOther: 'Użyj sztucznej inteligencji, aby automatycznie wypełnić dane ogłoszenia na podstawie przesłanych zdjęć. Funkcja analizuje zdjęcia i sugeruje tytuł, opis i inne szczegóły produktu.',
    autoCompleteButton: 'Auto-uzupełnij dane',
    autoCompleteUsed: 'Auto-uzupełnianie zostało użyte',
    citySearchNoResults: 'Niestety nie znaleziono lokalizacji. Spróbuj podać najbliższe większe miasto.',
    selectedCategory: 'Wybrana kategoria',
    quadForm: {
      title: 'Formularz ogłoszenia quada',
      comingSoon: 'Formularz dla quadów będzie dostępny wkrótce'
    },
    accessoriesForm: {
      title: 'Formularz ogłoszenia akcesoriów',
      comingSoon: 'Formularz dla akcesoriów będzie dostępny wkrótce'
    },
    partsForm: {
      title: 'Formularz ogłoszenia części',
      comingSoon: 'Formularz dla części będzie dostępny wkrótce'
    },
    servicesForm: {
      title: 'Formularz ogłoszenia usług',
      comingSoon: 'Formularz dla usług będzie dostępny wkrótce'
    },
    tiresForm: {
      title: 'Formularz ogłoszenia opon i felg',
      comingSoon: 'Formularz dla opon i felg będzie dostępny wkrótce'
    },
    comingSoon: {
      title: 'Wkrótce dostępne',
      description: 'Formularz dla kategorii "{category}" będzie dostępny wkrótce. Obecnie obsługujemy tylko ogłoszenia samochodów i quadów.'
    }
  },
  registerPage: {
    title: 'Rejestracja',
    email: 'E-mail',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    password: 'Hasło',
    passwordRepeat: 'Powtórz hasło',
    companyAccount: 'Konto firmowe',
    companyData: 'Dane firmowe',
    nip: 'NIP',
    companyName: 'Nazwa firmy',
    address: 'Adres',
    postalCode: 'Kod pocztowy',
    city: 'Miasto',
    registerBtn: 'Zarejestruj się',
    loading: 'Rejestracja...',
    successTitle: 'Rejestracja zakończona.',
    successMsg: 'Na podany adres e-mail został wysłany link aktywacyjny. Aby aktywować konto, kliknij w link w wiadomości.',
    goLogin: 'Przejdź do logowania',
    errorTitle: 'Błąd rejestracji',
    close: 'Zamknij',
    back: 'Wróć na stronę główną',
    passwordMismatch: 'Hasła nie są zgodne.',
    accountType: 'Typ konta',
    privateAccount: 'Konto prywatne',
    companyAccount: 'Konto firmowe',
    acceptTerms: 'Akceptuję Regulamin oraz Politykę prywatności',
    marketingConsent: 'Wyrażam zgodę na otrzymywanie wiadomości marketingowych (ogłoszenia promocyjne, newsletter, nowości w serwisie). Mogę w każdej chwili wycofać zgodę w ustawieniach konta.',
    marketingConsentNote: 'Wiadomości techniczne i operacyjne (potwierdzenia rejestracji, resetowanie hasła, powiadomienia o ogłoszeniach) będą wysyłane niezależnie od tej zgody.',
    privacyPolicy: 'Polityka prywatności',
    termsOfService: 'Regulamin'
  },
  registerVerification: {
    title: 'Weryfikacja konta',
    subtitle: 'Potwierdź swój adres email',
    successTitle: 'Weryfikacja udana',
    successMsg: 'Twoje konto zostało pomyślnie zweryfikowane. Możesz się teraz zalogować.',
    errorTitle: 'Błąd weryfikacji',
    errorMsg: 'Wystąpił błąd podczas weryfikacji konta. Spróbuj ponownie.',
    login: 'Przejdź do logowania',
    loading: 'Trwa weryfikacja...',
    noToken: 'Brak tokena weryfikacyjnego.',
    back: 'Wróć na stronę główną'
  },
  forgotPassword: {
    title: 'Odzyskiwanie hasła',
    email: 'E-mail',
    submit: 'Wyślij link do resetowania',
    loading: 'Wysyłanie...',
    successTitle: 'Link wysłany.',
    successMsg: 'Na podany adres e-mail został wysłany link do resetowania hasła.',
    errorTitle: 'Błąd',
    back: 'Wróć do logowania',
    close: 'Zamknij',
    emailRequired: 'Email jest wymagany'
  },
  resetPassword: {
    title: 'Resetowanie hasła',
    newPassword: 'Nowe hasło',
    confirmPassword: 'Potwierdź hasło',
    submit: 'Zresetuj hasło',
    loading: 'Resetowanie...',
    successTitle: 'Hasło zostało zmienione.',
    successMsg: 'Twoje hasło zostało pomyślnie zmienione. Za chwilę zostaniesz przekierowany do strony logowania.',
    errorTitle: 'Błąd',
    errorMsg: 'Nie udało się zresetować hasła.',
    back: 'Wróć do logowania',
    close: 'Zamknij',
    noToken: 'Brak tokena do resetowania hasła.',
    passwordMismatch: 'Hasła nie są zgodne.'
  },
  profile: {
    title: 'Profil',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    email: 'E-mail',
    phone: 'Telefon',
    location: 'Lokalizacja',
    about: 'O sprzedającym',
    aboutPlaceholder: 'Napisz kilka słów, które będą widoczne publicznie na twoim profilu.',
    changeProfilePhoto: 'Zmień zdjęcie profilowe',
    data: 'Dane',
    change: 'Zmień',
    saveSuccess: 'Dane profilu zostały zaktualizowane.',
    saveError: 'Nie udało się zapisać zmian. Spróbuj ponownie.',
    userDataError: 'Błąd pobierania danych użytkownika',
    username: 'Nazwa użytkownika',
    accountType: 'Typ konta',
    companyAccount: 'Konto firmowe',
    companyData: 'Dane firmy',
    nip: 'NIP',
    companyName: 'Nazwa firmy',
    address: 'Adres',
    postalCode: 'Kod pocztowy',
    city: 'Miasto',
    submenu: {
      profile: 'Profil',
      settings: 'Ustawienia'
    },
    citySearchNoResults: 'Niestety nie znaleziono lokalizacji. Spróbuj podać najbliższe większe miasto.'
  },
  about: {
    title: 'O nas',
    heroSubtitle: 'Tworzymy miejsce dla społeczności 4x4 - specjalistyczną platformę do wyszukiwania i sprzedaży pojazdów terenowych, wyprawowych, SUV-ów i innych pojazdów z napędem na cztery koła.',
    missionTitle: 'Nasza misja',
    missionDesc: 'Giełda4x4 powstała z potrzeby społeczności 4x4. Zauważyliśmy, że brakuje miejsca, gdzie można wygodnie wyszukiwać samochody z napędem na cztery koła, terenowe, wyprawowe i SUV-y z filtrami dostosowanymi do specyfiki tych pojazdów.',
    missionDesc2: 'Wiemy, że dwie najpopularniejsze platformy sprzedażowe aut są drogie, a nie spełniają potrzeb klientów szukających pojazdów 4x4. Chcemy, aby to miejsce stało się popularne i przyjazne dla społeczności 4x4.',
    specializedTitle: 'Specjalistyczne filtry',
    specializedDesc: 'Nasze filtry i atrybuty są dostosowane do specyfiki pojazdów 4x4:',
    feature1: 'Wyciągarka, opony typu MT, modyfikacje terenowe',
    feature2: 'Reduktor, snorkel, osłony podwozia',
    feature3: 'Bagażnik dachowy, klatka bezpieczeństwa, dodatkowe oświetlenie',
    problemTitle: 'Problem',
    problemDesc: 'Brak specjalistycznej platformy dla pojazdów 4x4. Popularne portale są drogie i nie oferują filtrów dostosowanych do specyfiki pojazdów terenowych.',
  },
  faq: {
    title: 'Często zadawane pytania',
    subtitle: 'Znajdź odpowiedzi na najczęstsze pytania dotyczące korzystania z Giełdy4x4',
    categoriesTitle: 'Kategorie',
    searchPlaceholder: 'Szukaj w pytaniach...',
    searchResults: 'Wyniki wyszukiwania',
    noResults: 'Nie znaleziono odpowiedzi na Twoje pytanie?',
    contactUs: 'Skontaktuj się z nami',
    categories: {
      general: 'Ogólne',
      registration: 'Rejestracja i konto',
      offers: 'Ogłoszenia',
      search: 'Wyszukiwanie',
      photos: 'Zdjęcia',
      autoFill: 'Automatyczne wypełnianie',
      wiki: 'Wiki i baza wiedzy',
      comparison: 'Porównywanie ogłoszeń',
      favorites: 'Ulubione',
      messaging: 'Wiadomości',
      payments: 'Płatności',
      privacy: 'Polityka prywatności',
      technical: 'Techniczne'
    },
    questions: {
      q1: {
        question: 'Jak mogę się zarejestrować na Giełdzie4x4?',
        answer: 'Aby się zarejestrować, kliknij przycisk "Zarejestruj się" w prawym górnym rogu strony. Wypełnij formularz rejestracyjny podając: imię, nazwisko, adres email, hasło (min. 8 znaków, zawierające wielką literę, małą literę i cyfrę), potwierdzenie hasła. Zaznacz akceptację regulaminu i polityki prywatności. Możesz też utworzyć konto firmowe dodając NIP i dane firmy. Po rejestracji otrzymasz email z linkiem weryfikacyjnym - kliknij w link, aby aktywować swoje konto. Bez weryfikacji nie będziesz mógł dodawać ogłoszeń.'
      },
      q2: {
        question: 'Jak dodać ogłoszenie o sprzedaży pojazdu?',
        answer: 'Po zalogowaniu kliknij przycisk "Dodaj ogłoszenie" w menu. Proces składa się z 3 kroków: 1) Podstawowe dane - wypełnij tytuł (min. 10 znaków), opis (min. 50 znaków), cenę, lokalizację (miasto), rok produkcji, przebieg, kategorię pojazdu i specyfikację (marka/model). 2) Wyposażenie i atrybuty - dodaj dodatkowe wyposażenie jak wyciągarka, opony MT, snorkel, osłony podwozia, bagażnik dachowy itp. 3) Zdjęcia - dodaj maksymalnie 10 zdjęć dobrej jakości z różnych kątów. Po wypełnieniu wszystkich wymaganych pól kliknij "Dodaj ogłoszenie". Ogłoszenie zostanie opublikowane po weryfikacji.'
      },
      q3: {
        question: 'Jakie zdjęcia mogę dodać do ogłoszenia?',
        answer: 'Możesz dodać maksymalnie 10 zdjęć w formatach JPG, PNG lub WebP. Zalecamy dodanie zdjęć z różnych kątów: przód, tył, boki, wnętrze, silnik, bagażnik. Zdjęcia powinny być dobrej jakości i pokazywać rzeczywisty stan pojazdu. Pierwsze zdjęcie będzie głównym zdjęciem ogłoszenia.'
      },
      q4: {
        question: 'Jak działa automatyczne wypełnianie danych pojazdu?',
        answer: 'Po wybraniu marki i modelu pojazdu, system automatycznie wypełni podstawowe dane techniczne (pojemność silnika, moc, typ nadwozia) na podstawie naszej bazy danych. Możesz również użyć funkcji "Automatyczne wypełnianie" po wprowadzeniu numeru VIN - system pobierze wtedy wszystkie dostępne dane z bazy danych pojazdów.'
      },
      q5: {
        question: 'Gdzie mogę znaleźć wiki z informacjami o pojazdach?',
        answer: 'Wiki znajduje się w menu głównym pod linkiem "Wiki". Zawiera szczegółowe informacje o różnych markach i modelach pojazdów 4x4, ich specyfikacjach technicznych, historii i charakterystyce. Możesz przeglądać kategorie lub wyszukiwać konkretne modele.'
      },
      q6: {
        question: 'Jak wyszukiwać ogłoszenia?',
        answer: 'Na stronie głównej lub w sekcji "Ogłoszenia" możesz użyć zaawansowanych filtrów: wybierz kategorię (SUV, Pick-up, Terrain), markę, model, rok produkcji, cenę, przebieg. Możesz też wpisać słowa kluczowe w polu wyszukiwania. Filtry można łączyć dla precyzyjnych wyników.'
      },
      q7: {
        question: 'Jak dodać ogłoszenie do ulubionych?',
        answer: 'Na stronie ogłoszenia kliknij ikonę serca obok tytułu. Ogłoszenie zostanie dodane do Twoich ulubionych i będzie dostępne w sekcji "Ulubione" w menu użytkownika. Możesz tam zarządzać swoją listą ulubionych ogłoszeń.'
      },
      q8: {
        question: 'Jak porównywać ogłoszenia?',
        answer: 'Na stronie ogłoszenia kliknij przycisk "Dodaj do porównania". Możesz dodać maksymalnie 4 ogłoszenia do porównania. Następnie przejdź do sekcji "Porównanie" w menu, gdzie zobaczysz wszystkie ogłoszenia obok siebie z porównaniem specyfikacji, ceny i atrybutów.'
      },
      q9: {
        question: 'Jak skontaktować się ze sprzedającym?',
        answer: 'Na stronie ogłoszenia znajdziesz przycisk "Wyślij wiadomość" lub "Kontakt". Kliknij go, aby otworzyć formularz wiadomości. Możesz też kliknąć na profil sprzedającego, aby zobaczyć więcej informacji o nim i jego innych ogłoszeniach.'
      },
      q10: {
        question: 'Czy mogę edytować swoje ogłoszenie po dodaniu?',
        answer: 'Tak, możesz edytować swoje ogłoszenia. Przejdź do swojego profilu i wybierz "Moje ogłoszenia". Znajdziesz tam listę wszystkich swoich ogłoszeń z opcją edycji. Możesz zmienić wszystkie dane, dodać lub usunąć zdjęcia.'
      },
      q11: {
        question: 'Jakie są wymagane pola przy dodawaniu ogłoszenia?',
        answer: 'Wymagane pola to: tytuł ogłoszenia (min. 10 znaków), opis (min. 50 znaków), cena (liczba dodatnia), kategoria pojazdu, miasto, rok produkcji, przebieg w kilometrach, specyfikacja pojazdu (marka i model). Dodatkowo zalecamy wypełnienie: numeru VIN, pojemności silnika, mocy silnika, typu paliwa, skrzyni biegów, koloru, liczby drzwi i miejsc. Im więcej informacji, tym większa szansa na szybką sprzedaż.'
      },
      q12: {
        question: 'Czy mogę dodać ogłoszenie bez rejestracji?',
        answer: 'Nie, aby dodać ogłoszenie musisz mieć zarejestrowane konto. To zapewnia bezpieczeństwo i weryfikację ogłoszeń. Rejestracja jest darmowa i szybka.'
      },
      q13: {
        question: 'Jak zmienić hasło do konta?',
        answer: 'W swoim profilu przejdź do "Ustawienia" i wybierz opcję zmiany hasła. Wprowadź aktualne hasło i nowe hasło (min. 8 znaków, zawierające wielką literę, małą literę i cyfrę). Możesz też użyć opcji "Zapomniałem hasła" na stronie logowania - wprowadź swój adres email, a otrzymasz link do resetowania hasła. Link jest ważny przez 24 godziny.'
      },
      q14: {
        question: 'Czy mogę dodać więcej niż jedno ogłoszenie?',
        answer: 'Tak, możesz dodać dowolną liczbę ogłoszeń. Każde ogłoszenie jest traktowane osobno i możesz je zarządzać z poziomu swojego profilu.'
      },
      q15: {
        question: 'Jak usunąć ogłoszenie?',
        answer: 'W sekcji "Moje ogłoszenia" w swoim profilu znajdź ogłoszenie, które chcesz usunąć, i kliknij przycisk "Usuń". Potwierdź usunięcie. Usunięte ogłoszenie nie będzie już widoczne dla innych użytkowników.'
      },
      q16: {
        question: 'Jakie są koszty dodawania ogłoszeń?',
        answer: 'Podstawowe dodawanie ogłoszeń jest całkowicie darmowe. Wszystkie podstawowe funkcje są darmowe i nie ma ukrytych kosztów.'
      },
      q17: {
        question: 'Jak sprawdzić historię moich ogłoszeń?',
        answer: 'W swoim profilu przejdź do "Moje ogłoszenia", gdzie zobaczysz wszystkie swoje aktywne i nieaktywne ogłoszenia. Możesz tam sprawdzić statystyki wyświetleń, liczbę wiadomości i status każdego ogłoszenia.'
      },
      q18: {
        question: 'Jak dodać zdjęcia do ogłoszenia?',
        answer: 'Na górze strony dodawania ogłoszenia kliknij "Dodaj zdjęcia" i wybierz pliki z komputera. Możesz przeciągnąć zdjęcia lub kliknąć w obszar wyboru. Zdjęcia zostaną automatycznie przeskalowane i zoptymalizowane. Możesz zmieniać kolejność zdjęć przeciągając je. Zdjęcia muszą być w formacie JPG, PNG lub WebP. Maksymalny rozmiar pliku to 10MB. Zalecamy rozdzielczość minimum 800x600 pikseli dla dobrej jakości wyświetlania.'
      },
      q19: {
        question: 'Jakie formaty zdjęć są obsługiwane?',
        answer: 'Obsługujemy formaty JPG, PNG i WebP. Maksymalny rozmiar pliku to 10MB. Zalecamy rozdzielczość minimum 800x600 pikseli dla dobrej jakości wyświetlania.'
      },
      q20: {
        question: 'Jak działa system wiadomości?',
        answer: 'Po kliknięciu "Wyślij wiadomość" na stronie ogłoszenia otworzy się formularz. Wprowadź temat i treść wiadomości (min. 10 znaków). Wiadomość zostanie wysłana do sprzedającego, który otrzyma powiadomienie email. Możesz śledzić konwersacje w sekcji "Wiadomości" w swoim profilu. Wiadomości są przechowywane przez 2 lata. Możesz też otrzymywać powiadomienia email o nowych wiadomościach - ustawienia znajdziesz w profilu.'
      },
      q21: {
        question: 'Jak sprawdzić lokalizację sprzedającego?',
        answer: 'Na stronie ogłoszenia znajdziesz informacje o lokalizacji sprzedającego (miasto, region). Niektóre ogłoszenia mają również mapę z dokładną lokalizacją. Możesz też kliknąć na profil sprzedającego, aby zobaczyć więcej szczegółów.'
      },
      q22: {
        question: 'Jak zgłosić nieprawidłowe ogłoszenie?',
        answer: 'Na stronie ogłoszenia znajdź przycisk "Zgłoś" lub "Zgłoś problem". Wypełnij formularz zgłoszenia, wybierając powód (nieprawidłowe dane, spam, nieodpowiednia treść). Nasz zespół sprawdzi zgłoszenie i podejmie odpowiednie działania.'
      },
      q23: {
        question: 'Jak sprawdzić wiarygodność sprzedającego?',
        answer: 'Kliknij na profil sprzedającego, aby zobaczyć jego historię, oceny od innych użytkowników, liczbę ogłoszeń i czas aktywności na platformie. Sprawdź też czy ma zweryfikowane konto i czy odpowiada na wiadomości.'
      },
      q24: {
        question: 'Jak zmienić dane w profilu?',
        answer: 'W swoim profilu kliknij "Edytuj profil" i zmień potrzebne dane: imię, nazwisko, email, telefon, lokalizację. Możesz też dodać zdjęcie profilowe i opis o sobie. Zmiany zapisujesz klikając "Zapisz".'
      },
      q25: {
        question: 'Jak sprawdzić status mojego ogłoszenia?',
        answer: 'W sekcji "Moje ogłoszenia" w profilu zobaczysz status każdego ogłoszenia: aktywne, oczekujące na moderację, nieaktywne. Możesz tam również sprawdzić statystyki wyświetleń i wiadomości.'
      },
      q26: {
        question: 'Jak moesz wesprzeć projekt?',
        answer: 'Prowadzimy portal bezołatnie i jesteśmy wdzięczni za kady typ wsparcia. W kadym mailu, stopce strony oraz w sekcji "O nas" znajdziesz informacje o tym jak możesz wesprzeć projekt.'
      },
      q27: {
        question: 'Jak sprawdzić historię wiadomości?',
        answer: 'W swoim profilu przejdź do sekcji "Wiadomości", gdzie znajdziesz wszystkie konwersacje z innymi użytkownikami. Możesz tam przeglądać historię wiadomości, odpowiadać i zarządzać kontaktami.'
      },
      q28: {
        question: 'Jak zmienić język interfejsu?',
        answer: 'Obecnie interfejs jest dostępny w języku polskim. W przyszłości planujemy dodać więcej języków. Możesz zmienić ustawienia w swoim profilu, gdy ta opcja będzie dostępna.'
      },
      q29: {
        question: 'Jak sprawdzić czy ogłoszenie jest nadal aktualne?',
        answer: 'Na stronie ogłoszenia sprawdź datę dodania i ostatniej aktualizacji. Możesz też wysłać wiadomość do sprzedającego, aby potwierdzić dostępność pojazdu. Aktywne ogłoszenia są regularnie aktualizowane przez sprzedających.'
      },
      q30: {
        question: 'Jak uzyskać pomoc techniczną?',
        answer: 'Jeśli masz problemy techniczne, skontaktuj się z nami przez formularz kontaktowy w sekcji "O nas" lub wyślij email na adres kontakt[at]gielda4x4.pl. Nasz zespół techniczny pomoże rozwiązać problem w możliwie najkrótszym czasie.'
      },
      q31: {
        question: 'Jakie dane osobowe są zbierane przez Giełdę4x4?',
        answer: 'Zbieramy tylko niezbędne dane: imię, nazwisko, adres email, numer telefonu (opcjonalnie), lokalizację. Dla kont firmowych dodatkowo: NIP, nazwę firmy, adres. Dane są używane wyłącznie do świadczenia usług platformy, komunikacji z użytkownikami i weryfikacji ogłoszeń. Nie sprzedajemy ani nie udostępniamy danych osobowych osobom trzecim bez Twojej zgody.'
      },
      q32: {
        question: 'Jak mogę usunąć swoje konto i dane?',
        answer: 'Możesz usunąć swoje konto w ustawieniach profilu lub wysyłać wniosek na adres kontakt[at]gielda4x4.pl. Po usunięciu konta wszystkie Twoje ogłoszenia zostaną usunięte, a dane osobowe zostaną trwale usunięte z naszych baz danych w ciągu 30 dni. Możesz też poprosić o eksport swoich danych przed usunięciem.'
      },
      q33: {
        question: 'Jakie są zasady bezpieczeństwa transakcji?',
        answer: 'Giełda4x4 to platforma ogłoszeniowa - nie uczestniczymy w transakcjach finansowych. Zalecamy: spotkanie w bezpiecznym miejscu, sprawdzenie dokumentów pojazdu, weryfikację numeru VIN, sprawdzenie historii serwisowej, test jazdy przed zakupem. Nie przekazuj pieniędzy przed obejrzeniem pojazdu. W razie wątpliwości skontaktuj się z nami.'
      },
      q34: {
        question: 'Jak zgłosić nieprawidłowe lub oszukańcze ogłoszenie?',
        answer: 'Na stronie ogłoszenia kliknij przycisk "Zgłoś" i wybierz powód: nieprawidłowe dane, spam, oszustwo, nieodpowiednia treść. Możesz też wysłać email na kontakt[at]gielda4x4.pl z opisem problemu. Nasz zespół sprawdzi zgłoszenie w ciągu 24 godzin i podejmie odpowiednie działania. W przypadku oszustwa powiadomimy odpowiednie służby.'
      },
      q35: {
        question: 'Jakie są limity i ograniczenia platformy?',
        answer: 'Limity: maksymalnie 10 zdjęć na ogłoszenie, maksymalnie 4 ogłoszenia w porównaniu, maksymalnie 50 ulubionych ogłoszeń. Ogłoszenia są aktywne przez liczbę dni wskazaną podczas dodawania (np. 30 dni, po czym wymagają odnowienia). Możesz dodać dowolną liczbę ogłoszeń. Ogłoszenia premium mają priorytetowe wyświetlanie i dłuższy czas aktywności.'
      }
    }
  },
  about: {
    title: 'O nas',
    heroSubtitle: 'Poznaj historię Giełdy4x4 - największego portalu ogłoszeń pojazdów z napędem na cztery koła w Polsce',
    missionTitle: 'Nasza misja',
    missionDesc: 'Stworzyliśmy Giełdę4x4 z myślą o społeczności entuzjastów pojazdów terenowych. Naszym celem jest zapewnienie bezpiecznej i przyjaznej platformy do kupna i sprzedaży pojazdów 4x4.',
    missionDesc2: 'Wierzymy, że każdy miłośnik off-roadu zasługuje na miejsce, gdzie może znaleźć swój wymarzony pojazd lub sprzedać obecny, mając pewność, że trafia do odpowiednich osób.',
    specializedTitle: 'Specjalizacja 4x4',
    specializedDesc: 'Nasza platforma jest dedykowana wyłącznie pojazdom z napędem na cztery koła, co oznacza:',
    feature1: 'Filtry dostosowane do potrzeb 4x4',
    feature2: 'Wiedza ekspercka w dziedzinie pojazdów terenowych',
    feature3: 'Społeczność pasjonatów off-roadu',
    problemTitle: 'Problem i rozwiązanie',
    problemDesc: 'Tradycyjne portale ogłoszeniowe nie rozumieją specyfiki pojazdów 4x4. Brakuje specjalistycznych filtrów, a ogłoszenia są rozproszone między różnymi kategoriami.',
    solutionTitle: 'Nasze rozwiązanie',
    solutionDesc: 'Stworzyliśmy miejsce, gdzie wszystkie pojazdy 4x4 mogą być w jednym miejscu z filtrami dostosowanymi do potrzeb społeczności 4x4.',
    communityTitle: 'Dla społeczności 4x4',
    communityDesc: 'Włożyliśmy w to całe nasze doświadczenie motoryzacyjne oraz miesiące pracy nad tą platformą. Chcemy, aby to miejsce stało się popularne i przyjazne dla społeczności 4x4.',
    communityDesc2: 'Można się z nami podzielić sugestiami i pomysłami na rozwój platformy. Jeśli uważasz, że to fajny pomysł i chcesz nas wspierać, to po prostu postaw nam kawę!',
    supportTitle: 'Wesprzyj nasz projekt',
    supportDesc: 'Jeśli uważasz, że to fajny pomysł i chcesz nas wspierać, to po prostu postaw nam kawę!',
    buyCoffee: 'Postaw kawę',
    contactUs: 'Skontaktuj się z nami',
    contactTitle: 'Skontaktuj się z nami',
    contactDesc: 'Masz sugestie lub pomysły? Chętnie je poznamy!',
    email: 'Email',
    emailPlaceholder: 'Twój adres email',
    message: 'Wiadomość',
    messagePlaceholder: 'Twoja wiadomość lub sugestia...',
    send: 'Wyślij',
    cancel: 'Anuluj'
  },
  categorySelect: {
    brand: 'Marka',
    chooseBrand: 'Wybierz markę',
    model: 'Model',
    chooseModel: 'Wybierz model',
    selectMainCategoryFirst: 'Najpierw wybierz główną kategorię w oknie powyżej',
    brandGroups: {
      popular: 'Popularne',
      other: 'Pozostałe',
      otherBrands: 'Inne'
    }
  },
  app: {
    title: 'Giełda4x4',
    subtitle: 'Portal ogłoszeń',
    offers: 'Ogłoszenia',
    addOffer: 'Dodaj ogłoszenie',
    compare: 'Porównaj',
    logout: 'Wyloguj się',
    footer: {
      title: 'Giełda4x4',
      description: 'Największy portal ogłoszeń pojazdów z napędem na cztery koła w Polsce',
      quickLinks: 'Szybkie linki',
      allOffers: 'Wszystkie ogłoszenia',
      addOffer: 'Dodaj ogłoszenie',
      about: 'O nas',
      faq: 'FAQ',
      contact: 'Kontakt',
      email: 'Email: {address}',
      phone: 'Tel: +48 123 456 789',
      followUs: 'Obserwuj nas',
      joinCommunity: 'Dołącz do społeczności na Facebooku',
      facebookGroup: 'Grupa Giełda4x4',
      joinGroup: 'Dołącz do grupy',
      copyright: '© 2025 Giełda4x4. Wszelkie prawa zastrzeżone. | Właścicielem serwisu jest Codefi, NIP: 7343296104',
      privacy: 'Polityka prywatności',
      rules: 'Regulamin',
      pricing: 'Cennik',
      partnership: 'Reklama i partnerstwo',
      wiki: 'Baza wiedzy',
      privacySettings: 'Ustawienia prywatności'
    }
  },
  specification: {
    generation: 'Generacja',
    productionYears: 'Lata produkcji',
    version: 'Wersja',
    engineVersion: 'Wersja silnika',
    driveType: 'Typ napędu',
    driveName: 'Napęd',
    bodyType: 'Typ nadwozia',
    selectGeneration: 'Wybierz generację',
    selectProductionYear: 'Wybierz rok produkcji',
    selectVersion: 'Wybierz wersję',
    selectEngine: 'Wybierz silnik',
    selectDriveType: 'Wybierz typ napędu',
    selectDriveName: 'Wybierz nazwę napędu',
    selectBodyType: 'Wybierz typ nadwozia',
    hasTerrainModes: 'Modyfikacje terenowe',
    terrainCapabilities: 'Zdolności terenowe',
    constructionType: 'Typ konstrukcji',
    hasReductor: 'Reduktor',
    selectionRequired: 'Wybierz specyfikację',
    noSpecificationsFound: 'Nie znaleziono specyfikacji',
    different: 'Inna specyfikacja'
  },
  attributes: {
    'Stan pojazdu': 'Stan pojazdu',
    'Osłony podwozia': 'Osłony podwozia',
    'Bezkluczykowy dostęp': 'Bezkluczykowy dostęp',
    'System multimedialny': 'System multimedialny',
    'Rodzaj paliwa': 'Rodzaj paliwa',
    'Skrzynia biegów': 'Skrzynia biegów',
    'Napęd 4x4': 'Napęd 4x4',
    'Typ nadwozia': 'Typ nadwozia',
    'Kraj pochodzenia': 'Kraj pochodzenia',
    'Konstrukcja': 'Konstrukcja',
    'Forma Sprzedaży': 'Forma Sprzedaży',
    'Wyciągarka': 'Wyciągarka',
    'Blokada dyferencjału': 'Blokada dyferencjału',
    'Lift zawieszenia': 'Lift zawieszenia',
    'Opony terenowe': 'Opony terenowe',
    'Snorkel': 'Snorkel',
    'Bagażnik dachowy': 'Bagażnik dachowy',
    'Klatka bezpieczeństwa': 'Klatka bezpieczeństwa',
    'Zbiornik dodatkowego paliwa': 'Zbiornik dodatkowego paliwa',
    'Dodatkowe oświetlenie': 'Dodatkowe oświetlenie',
    'Reduktor': 'Reduktor',
    'Możliwości terenowe': 'Możliwości terenowe',
    'Zderzaki': 'Zderzaki',
    'Progi': 'Progi',
    'Namiot dachowy': 'Namiot dachowy',
    'Zabudowa kempingowa': 'Zabudowa kempingowa',
    'Ogrzewanie postojowe': 'Ogrzewanie postojowe',
    'Markiza': 'Markiza',
    'Dodatkowe akumulatory': 'Dodatkowe akumulatory',
    'Przetwornica napięcia': 'Przetwornica napięcia',
    'Lodówka': 'Lodówka',
    'Zbiorniki na wodę': 'Zbiorniki na wodę',
    'Instalacja solarna': 'Instalacja solarna',
    'Liczba drzwi': 'Liczba drzwi',
    'Liczba miejsc': 'Liczba miejsc',
    'Kolor nadwozia': 'Kolor nadwozia',
    'Kolor wnętrza': 'Kolor wnętrza',
    'Materiał tapicerki': 'Materiał tapicerki',
    'Rodzaj dachu': 'Rodzaj dachu',
    'Klimatyzacja': 'Klimatyzacja',
    'Tempomat': 'Tempomat',
    'Hak': 'Hak',
    'Podgrzewane fotele': 'Podgrzewane fotele',
    'Wentylowane fotele': 'Wentylowane fotele',
    'Elektrycznie regulowane fotele': 'Elektrycznie regulowane fotele',
    'Podgrzewana kierownica': 'Podgrzewana kierownica',
    'Elektryczne szyby': 'Elektryczne szyby',
    'Elektrycznie sterowane lusterka': 'Elektrycznie sterowane lusterka',
    'Centralny zamek': 'Centralny zamek',
    'System audio': 'System audio',
    'Kamera cofania': 'Kamera cofania',
    'Czujniki parkowania': 'Czujniki parkowania',
    'Podstawowe': 'Podstawowe',
    'Wyposażenie offroad': 'Wyposażenie offroad',
    'Wyposażenie overlanding': 'Wyposażenie overlanding',
    'Nadwozie i wnętrze': 'Nadwozie i wnętrze',
    'Wyposażenie standardowe': 'Wyposażenie standardowe'
  },
  groups: {
    'Podstawowe': 'Podstawowe',
    'Wyposażenie offroad': 'Wyposażenie offroad',
    'Wyposażenie overlanding': 'Wyposażenie overlanding',
    'Nadwozie i wnętrze': 'Nadwozie i wnętrze',
    'Wyposażenie standardowe': 'Wyposażenie standardowe'
  },
  offer: {
    successTitle: 'Sukces.',
    errorTitle: 'Błąd',
    fetchError: 'Nie udało się pobrać danych ogłoszenia.',
    operationError: 'Wystąpił błąd podczas operacji na ofercie.',
    addSuccess: 'Ogłoszenie zostało dodana pomyślnie.',
    editSuccess: 'Ogłoszenie zostało zaktualizowana pomyślnie.',
    view: 'Zobacz ogłoszenie',
    close: 'Zamknij',
    invalidYear: 'Nieprawidłowy rok produkcji'
  },
  editOfferPage: {
    title: 'Edytuj ogłoszenie',
    description: 'Edytuj swoje ogłoszenie pojazdu terenowego na Giełda4x4. Zaktualizuj informacje, zdjęcia i szczegóły oferty.',
    submit: 'Zapisz zmiany',
    form: {
      edit: 'Zapisz zmiany'
    },
    tooltips: {
      submitting: 'Trwa zapisywanie zmian...',
      uploading: 'Trwa wgrywanie zdjęć...',
      noImages: 'Dodaj co najmniej jedno zdjęcie, aby kontynuować'
    }
  },
  wiki: {
    categories: {
      title: 'Katalog samochodów',
      loading: 'Ładowanie kategorii...',
      noCategories: 'Brak dostępnych kategorii',
      noBrands: 'Brak dostępnych marek',
      noModels: 'Brak dostępnych modeli'
    },
    modelDetails: {
      title: 'Szczegóły modelu',
      loading: 'Ładowanie szczegółów modelu...',
      notFound: 'Nie znaleziono szczegółów modelu',
      backToCatalog: 'Powrót do katalogu',
      forWho: 'Dla kogo',
      generations: 'Generacje',
      versions: 'Wersje wyposażenia',
      engines: 'Silniki',
      engineName: 'Nazwa silnika',
      power: 'Moc',
      torque: 'Moment obrotowy',
      drive: 'Napęd',
      pros: 'Zalety',
      cons: 'Wady',
      relatedOffers: 'Ogłoszenia tego modelu',
      noOffers: 'Brak ogłoszeń do wyświetlenia.',
      noEngines: 'Brak dostępnych silników'
    }
  },
  offerCarousel: {
    noOffers: 'Brak ogłoszeń do wyświetlenia.',
    fuelType: 'Rodzaj paliwa'
  },
  profilePage: {
    title: 'Mój profil',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    updateBtn: 'Aktualizuj profil',
    success: 'Profil zaktualizowany',
    error: 'Błąd',
    close: 'Zamknij',
    buyCoffee: 'Postaw nam kawę',
    supportDevelopment: 'Wesprzyj rozwój portalu i postaw nam kawę'
  },
  userMenu: {
    login: 'Zaloguj się',
    profile: 'Profil',
    myOffers: 'Moje ogłoszenia',
    favorites: 'Ulubione',
    settings: 'Ustawienia',
    logout: 'Wyloguj',
    user: 'Użytkownik'
  },
  userOffers: {
    title: 'Moje ogłoszenia',
    loading: 'Ładowanie ogłoszeń...',
    noOffers: 'Nie masz jeszcze żadnych ogłoszeń.',
    preview: 'Podgląd',
    edit: 'Edytuj',
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
    extend: 'Przedłuż',
    raise: 'Podbij',
    delete: 'Usuń',
    active: 'Aktywne',
    inactive: 'Nieaktywne',
    activeUntil: 'Aktywne do',
    honorUntil: 'Wyróżnione do',
    expired: 'wygasło',
    deleteConfirm: 'Czy na pewno chcesz usunąć to ogłoszenie?',
    toggleError: 'Błąd podczas zmiany aktywności ogłoszenia.',
    deleteError: 'Błąd podczas usuwania ogłoszenia.',
    raiseError: 'Błąd podczas podbicia ogłoszenia.',
    raiseSuccess: 'Ogłoszenie zostało podbite',
    raiseSuccessMessage: 'Twoje ogłoszenie zostało przeniesione na początek listy.',
    printPdf: 'Wydrukuj PDF',
    pdfError: 'Błąd pobierania PDF',
    views: 'Wyświetlenia',
    deactivationModal: {
      title: 'Dezaktywuj ogłoszenie',
      subtitle: 'Wybierz powód deaktywacji ogłoszenia:',
      soldOnGielda4x4: 'Auto zostało sprzedane dzięki Giełda4x4',
      soldOutsideGielda4x4: 'Sprzedane poza Giełda4x4',
      errorsInOffer: 'Błędy w ogłoszeniu',
      cancelledSale: 'Zrezygnowałem ze sprzedaży',
      other: 'Inne',
      customReasonPlaceholder: 'Podaj szczegółowy powód...',
      deactivate: 'Dezaktywuj',
      cancel: 'Anuluj',
      success: 'Ogłoszenie zostało deaktywowane',
      error: 'Błąd podczas deaktywacji ogłoszenia'
    },
    deleteModal: {
      title: 'Usuń ogłoszenie',
      subtitle: 'Wybierz powód usunięcia ogłoszenia:',
      soldOnGielda4x4: 'Auto zostało sprzedane dzięki Giełda 4x4',
      soldOutsideGielda4x4: 'Sprzedane poza Giełda 4x4',
      errorsInOffer: 'Błędy w ogłoszeniu',
      cancelledSale: 'Zrezygnowałem ze sprzedaży',
      other: 'Inne',
      customReasonPlaceholder: 'Podaj szczegółowy powód...',
      delete: 'Usuń',
      cancel: 'Anuluj',
      success: 'Ogłoszenie zostało usunięte',
      error: 'Błąd podczas usuwania ogłoszenia'
    }
  },
  galleryUploader: {
    addPhotos: 'Dodaj zdjęcia',
    dragDrop: 'Przeciągnij i upuść zdjęcia tutaj',
    remove: 'Usuń',
    uploadError: 'Błąd podczas uploadu zdjęcia.',
    updateError: 'Błąd podczas aktualizacji galerii.',
    authError: 'Błąd autoryzacji. Zaloguj się ponownie.',
    authRequired: 'Musisz być zalogowany, aby dodawać i zarządzać zdjęciami.',
    mainPhoto: 'Zdjęcie główne',
    setAsMain: 'Ustaw jako główne',
    powerConversion: 'Przeliczanie mocy silnika:',
    powerFormula1: '1 KM = 0.7355 kW',
    powerFormula2: '1 kW = 1.3596 KM',
    powerExample: 'Przykład: 100 KM = 73.55 kW',
    autoFillButton: 'Autouzupełnianie ogłoszenia',
    autoFillAlreadyUsed: 'Autouzupełnianie zostało już użyte dla tego ogłoszenia',
    maxImagesReached: 'Maksymalnie {max} zdjęć może być dodanych do ogłoszenia.',
    images: 'zdjęć'
  },
  profileImageUploader: {
    changeImage: 'Zmień zdjęcie',
    uploading: 'Przesyłanie...',
    authRequired: 'Musisz być zalogowany, aby zmienić zdjęcie profilowe',
    authError: 'Błąd autoryzacji. Zaloguj się ponownie.',
    uploadError: 'Błąd podczas przesyłania zdjęcia',
    invalidFileType: 'Nieprawidłowy typ pliku. Wybierz obraz.'
  },
  autoFillModal: {
    title: 'Autouzupełnianie ogłoszenia',
    vinLabel: 'Numer VIN',
    vinPlaceholder: 'Wprowadź 17-znakowy numer VIN',
    productionYearLabel: 'Rok produkcji',
    productionYearPlaceholder: 'Wprowadź rok produkcji (opcjonalnie)',
    selectImagesLabel: 'Wybierz zdjęcia do analizy',
    maxImages: 'maksymalnie 2',
    selectionInfo: 'Wybierz zdjęcia, które chcesz przeanalizować w celu automatycznego uzupełnienia danych ogłoszenia',
    timeoutInfo: 'Uwaga: Analiza może potrwać do 60 sekund. Prosimy o cierpliwość.',
    autoFill: 'Autouzupełnij',
    cancel: 'Anuluj',
    processing: 'Przetwarzanie...',
    success: 'Dane zostały uzupełnione w miarę możliwości. Sprawdź wszystkie informacje przed wysłaniem ogłoszenia.',
    error: 'Błąd podczas autouzupełniania ogłoszenia',
    rateLimitExceeded: 'Przekroczono limit autouzupełniania',
    hourlyLimitExceeded: 'Przekroczono limit godzinowy. Maksymalnie 5 prób na godzinę.',
    dailyLimitExceeded: 'Przekroczono limit dzienny. Maksymalnie 10 prób dziennie.',
    tooltip: {
      vinRequired: 'Numer VIN musi mieć dokładnie 17 znaków',
      imageRequired: 'Wybierz co najmniej jedno zdjęcie do analizy',
      tooManyImages: 'Można wybrać maksymalnie 2 zdjęcia'
    }
  },
  autoFillPreloader: {
    title: 'Autouzupełnianie w toku',
    subtitle: 'Analizujemy dane i uzupełniamy ogłoszenie'
  },
  errors: {
    serverError: 'Nieprawidłowa odpowiedź serwera.',
    verificationError: 'Nie udało się zweryfikować konta.',
    uploadError: 'Błąd uploadu zdjęcia',
    offerAddError: 'Błąd podczas dodawania ogłoszenia',
    userDataError: 'Błąd podczas pobierania danych użytkownika:',
    locationError: 'Błąd podczas pobierania danych lokalizacji:',
    citySearchError: 'Błąd podczas wyszukiwania miasta:',
    categoryError: 'Błąd podczas pobierania kategorii:',
    brandError: 'Błąd podczas pobierania marek:',
    subcategoryError: 'Błąd podczas pobierania podkategorii:',
    modelDetailsError: 'Błąd podczas pobierania szczegółów modelu:',
    offerError: 'Błąd podczas operacji na ofercie:',
    offerFetchError: 'Błąd pobierania ogłoszenia:'
  },
  favoritesPage: {
    title: 'Moje ulubione',
    offers: 'Ogłoszenia',
    searches: 'Wyszukiwania',
    loading: 'Ładowanie...',
    retry: 'Spróbuj ponownie',
    noFavoriteOffers: 'Brak ulubionych ogłoszeń',
    noFavoriteOffersDescription: 'Nie masz jeszcze żadnych ulubionych ogłoszeń. Przeglądaj ogłoszenia i dodawaj je do ulubionych.',
    noFavoriteSearches: 'Brak zapisanych wyszukiwań',
    noFavoriteSearchesDescription: 'Nie masz jeszcze żadnych zapisanych wyszukiwań. Użyj funkcji "Zapisz wyszukiwanie" podczas przeglądania ogłoszeń.',
    browseOffers: 'Przeglądaj ogłoszenia',
    startSearching: 'Rozpocznij wyszukiwanie',
    added: 'Dodano',
    saved: 'Zapisano',
    seeDetails: 'Zobacz szczegóły',
    use: 'Użyj',
    useSearch: 'Użyj tego wyszukiwania',
    deleteSearch: 'Usuń wyszukiwanie',
    confirmDeleteSearch: 'Czy na pewno chcesz usunąć to wyszukiwanie?'
  },
  favoriteButton: {
    addToFavorites: 'Dodaj do ulubionych',
    removeFromFavorites: 'Usuń z ulubionych'
  },
  loginModal: {
    title: 'Zaloguj się',
    message: 'Aby dodać ogłoszenie do ulubionych, musisz być zalogowany.',
    email: 'E-mail',
    password: 'Hasło',
    emailPlaceholder: 'Wprowadź swój e-mail',
    passwordPlaceholder: 'Wprowadź swoje hasło',
    login: 'Zaloguj się',
    register: 'Zarejestruj się',
    loggingIn: 'Logowanie...',
    loginError: 'Błąd logowania',
    forgotPassword: 'Nie pamiętasz hasła?'
  },
  saveSearchModal: {
    title: 'Zapisz wyszukiwanie',
    name: 'Nazwa',
    namePlaceholder: 'Wprowadź nazwę dla tego wyszukiwania',
    preview: 'Podgląd kryteriów',
    cancel: 'Anuluj',
    save: 'Zapisz',
    saving: 'Zapisywanie...',
    notAuthenticated: 'Musisz być zalogowany, aby zapisać wyszukiwanie',
    nameRequired: 'Nazwa jest wymagana',
    saveError: 'Błąd podczas zapisywania wyszukiwania'
  },
  favorites: {
    title: 'Moje ulubione',
    description: 'Zarządzaj swoimi ulubionymi ogłoszeniami i zapisanymi wyszukiwaniami',
    noFavoriteOffers: 'Brak ulubionych ogłoszeń',
    noFavoriteOffersDescription: 'Nie masz jeszcze żadnych ulubionych ogłoszeń. Przeglądaj ogłoszenia i dodawaj je do ulubionych.',
    noFavoriteSearches: 'Brak zapisanych wyszukiwań',
    noFavoriteSearchesDescription: 'Nie masz jeszcze żadnych zapisanych wyszukiwań. Użyj funkcji "Zapisz wyszukiwanie" podczas przeglądania ogłoszeń.',
    browseOffers: 'Przeglądaj ogłoszenia',
    saveSearch: 'Zapisz wyszukiwanie',
    saveSearchDescription: 'Zapisz obecne kryteria wyszukiwania, aby móc je później łatwo przywołać.',
    searchName: 'Nazwa wyszukiwania',
    searchNamePlaceholder: 'Wprowadź nazwę dla tego wyszukiwania',
    save: 'Zapisz',
    loadSearch: 'Wczytaj wyszukiwanie',
    savedOn: 'Zapisano',
    notifications: 'Powiadomienia',
    notificationsOfferTooltip: 'Włącz powiadomienia e-mail o zmianach w tej ofercie',
    notificationsSearchTooltip: 'Włącz powiadomienia e-mail o nowych ogłoszeniach dla tego wyszukiwania'
  },
  messages: {
    title: 'Wiadomości',
    sendMessage: 'Wyślij wiadomość',
    message: 'Wiadomość',
    messagePlaceholder: 'Napisz wiadomość do sprzedawcy...',
    send: 'Wyślij',
    sending: 'Wysyłanie...',
    sentSuccessfully: 'Wiadomość została wysłana pomyślnie.',
    sendError: 'Błąd podczas wysyłania wiadomości',
    loginRequired: 'Musisz być zalogowany, aby wysłać wiadomość',
    sellerNotFound: 'Nie można znaleźć sprzedawcy',
    offerNotFound: 'Nie można znaleźć ogłoszenia',
    characters: 'znaków',
    messageTooLong: 'Wiadomość nie może być dłuższa niż 256 znaków',
    conversations: 'Konwersacje',
    unreadMessages: 'Nieprzeczytane wiadomości',
    markAsRead: 'Oznacz jako przeczytane',
    noMessages: 'Brak wiadomości',
    reply: 'Odpowiedz',
    delete: 'Usuń',
    deleteConfirm: 'Czy na pewno chcesz usunąć tę wiadomość?',
    unread: 'nieprzeczytane',
    viewConversation: 'Zobacz konwersację',
    loadError: 'Błąd podczas ładowania konwersacji',
    conversationLoadError: 'Błąd podczas ładowania konwersacji',
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
    justNow: 'Przed chwilą',
    minutesAgo: 'min temu',
    you: 'Ty',
    description: 'Zarządzaj swoimi wiadomościami i konwersacjami',
    loading: 'Ładowanie konwersacji...',
    errorTitle: 'Błąd',
    retry: 'Spróbuj ponownie',
    noConversations: 'Brak konwersacji',
    noConversationsDescription: 'Nie masz jeszcze żadnych konwersacji. Rozpocznij rozmowę z sprzedawcą, aby zobaczyć wiadomości tutaj.',
    browseOffers: 'Przeglądaj ogłoszenia',
    viewOffer: 'Zobacz ogłoszenie',
    loadMore: 'Załaduj więcej',
    blockedByYou: 'Zablokowałeś tego użytkownika. Nie możesz wysyłać wiadomości.',
    blockedByUser: 'Ten użytkownik zablokował Cię. Nie możesz wysyłać wiadomości.',
    cannotSendBlockedByYou: 'Nie możesz wysyłać wiadomości - zablokowałeś tego użytkownika',
    cannotSendBlockedByUser: 'Nie możesz wysyłać wiadomości - użytkownik Cię zablokował',
    securityWarning: {
      title: 'Bezpieczeństwo w komunikacji',
      description: 'Pamiętaj o podstawowych zasadach bezpieczeństwa podczas komunikacji online:',
      tips: [
        'Nie udostępniaj danych osobowych (PESEL, numer dowodu, adres zamieszkania)',
        'Nie podawaj informacji o kartach płatniczych, kontach bankowych czy hasłach',
        'Uważaj na zaliczki - nie płac z góry za rzeczy, których nie widziałeś',
        'Nie klikaj w podejrzane linki wysyłane przez użytkowników',
        'Spotykaj się w bezpiecznych, publicznych miejscach',
        'Ufaj swojej intuicji - jeśli coś wydaje się podejrzane, przerwij kontakt',
        'Zgłaszaj podejrzane zachowania użytkowników'
      ],
      learnMore: 'Dowiedz się więcej o bezpieczeństwie',
      dismiss: 'Rozumiem'
    }
  },
  userActions: {
    blockUser: 'Zablokuj',
    unblockUser: 'Odblokuj',
    reportUser: 'Zgłoś',
    alreadyReported: 'Już zgłoszony',
    blockedByUser: 'Zablokowany przez użytkownika',
    blockDescription: 'Zablokowanie użytkownika spowoduje, że nie będziesz mógł wysyłać mu wiadomości.',
    reportDescription: 'Zgłoszenie użytkownika pomoże nam utrzymać wysoką jakość naszej platformy. Twoje zgłoszenie zostanie przeanalizowane przez nasz zespół.',
    blockWarning: 'Po zablokowaniu użytkownika nie będziesz mógł z nim rozmawiać. Możesz go odblokować w każdej chwili.',
    reportWarning: 'Zgłoszenia są poufne. Używaj tej funkcji tylko w przypadku naruszenia regulaminu.',
    reason: 'Powód',
    reasonPlaceholder: 'Opisz powód zgłoszenia...',
    reasonRequired: 'Powód zgłoszenia jest wymagany',
    characters: 'znaków',
    block: 'Zablokuj',
    report: 'Zgłoś',
    blockSuccess: 'Użytkownik został zablokowany',
    reportSuccess: 'Użytkownik został zgłoszony',
    blockError: 'Błąd podczas blokowania użytkownika',
    reportError: 'Błąd podczas zgłaszania użytkownika',
    processing: 'Przetwarzanie...',
    unauthorized: 'Musisz być zalogowany, aby wykonać tę akcję'
  },
  settings: {
    title: 'Ustawienia',
    password: 'Hasło',
    currentPassword: 'Obecne hasło',
    newPassword: 'Nowe hasło',
    repeatPassword: 'Powtórz hasło',
    passwordRequirements: 'Hasło powinno mieć przynajmniej 8 znaków, małe i wielkie litery, cyfry oraz znaki specjalne.',
    passwordChangeSuccess: 'Hasło zostało zmienione.',
    passwordChangeError: 'Nie udało się zmienić hasła.',
    passwordMismatch: 'Nowe hasła nie są takie same.',
    passwordTooShort: 'Hasło musi mieć co najmniej 8 znaków.',
    deleteAccount: 'Usuń konto',
    deleteAccountTitle: 'Usuwanie konta',
    deleteAccountDesc: 'Usunięcie konta jest nieodwracalne i w jego efekcie wszystkie Twoje dane zostaną usunięte. Z powodów prawnych, niektóre dane mogą zostać przez nas zachowane.',
    deleteAccountConfirmTitle: 'Potwierdź usunięcie konta',
    deleteAccountConfirmMsg: 'Czy na pewno chcesz usunąć konto? Ta operacja jest nieodwracalna i wszystkie Twoje dane zostaną usunięte.',
    deleteAccountSuccess: 'Twoje konto zostało oznaczone do usunięcia.',
    deleteAccountError: 'Nie udało się usunąć konta.',
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
    dangerZone: 'Niebezpieczna sekcja'
  },
  notifications: {
    success: 'Sukces',
    error: 'Błąd',
    close: 'Zamknij'
  },
  activation: {
    title: 'Aktywacja/Przedłużenie ogłoszenia',
    subtitle: 'Wybierz produkty, które chcesz aktywować dla swojej ogłoszenia',
    offerProducts: {
      title: 'Czas widoczności ogłoszenia',
      description: 'Wybierz jak długo twoje ogłoszenie ma być aktywne',
      badge: 'Ogłoszenie'
    },
    honorProducts: {
      title: 'Wyróżnienia',
      description: 'Wyróżnienia, które zwiększą widoczność Twojej ogłoszenia',
      badge: 'Wyróżnienie'
    },
    honorAndRaisingProducts: {
      title: 'Wyróżnienia i Podbicia',
      description: 'Wyróżnienia i podbicia, które zwiększą widoczność Twojej ogłoszenia'
    },
    raisingProducts: {
      title: 'Podbicia',
      description: 'Podbicia, które przeniosą ogłoszenie na początek listy',
      badge: 'Podbicie',
      rasings: 'Liczba podbić'
    },
    partnerHonorProducts: {
      badge: 'Wyróżnienie Partnera'
    },
    duration: 'Czas trwania',
    days: 'dni',
    perOffer: 'na ogłoszenie',
    select: 'Wybierz',
    selected: 'Wybrane',
    remove: 'Usuń',
    total: 'Razem',
    totalDescription: 'Łączna kwota do zapłaty',
    proceedToPayment: 'Przejdź do płatności',
    activateFree: 'Aktywuj za darmo',
    free: 'Za darmo',
    processing: 'Przetwarzanie...',
    changeSelection: 'Zmień wybór',
    summary: {
      title: 'Podsumowanie',
      description: 'Sprawdź wybrane produkty przed płatnością',
      empty: 'Wybierz produkty, aby zobaczyć podsumowanie'
    },
    promoCode: {
      title: 'Kod promocyjny',
      placeholder: 'Wprowadź kod promocyjny',
      apply: 'Zastosuj',
      validating: 'Sprawdzanie...',
      success: 'Kod promocyjny został zastosowany pomyślnie!',
      error: 'Nieprawidłowy lub nieaktywny kod promocyjny',
      noOffer: 'Brak informacji o ogłoszeniu. Odśwież stronę i spróbuj ponownie.',
      saved: 'Oszczędzasz {amount}'
    },
    retry: 'Spróbuj ponownie',
    fetchError: 'Błąd podczas pobierania produktów',
    offerFetchError: 'Błąd podczas pobierania ogłoszenia',
    noOfferId: 'Brak identyfikatora ogłoszenia',
    offerNotActiveNoProduct: 'Nie można utworzyć sesji płatności: ogłoszenie nie jest aktywne i nie wybrano produktu ogłoszenia.',
    freemiumUsed: {
      title: 'Freemium już wykorzystane',
      description: 'Darmowy produkt został już wykorzystany dla tego ogłoszenia.',
      warning: 'Niedostępne',
      tooltip: 'Ten produkt jest niedostępny - freemium już wykorzystane',
      unavailable: 'Niedostępne'
    },
    success: {
      title: 'Płatność zakończona pomyślnie.',
      description: 'Twoja oferta jest aktywna. Dziękujemy za zakup.',
      freemium: {
        title: 'Aktywacja zakończona pomyślnie.',
        description: 'Twoja ogłoszenie zostało aktywowane za darmo.',
        info: {
          title: 'Darmowa aktywacja',
          description: 'Twoja ogłoszenie zostało aktywowane bezpłatnie. Możesz teraz korzystać z wszystkich funkcji.'
        }
      },
      loading: 'Potwierdzanie płatności...',
      paymentDetails: 'Szczegóły płatności',
      amount: 'Kwota',
      transactionId: 'ID transakcji',
      viewOffer: 'Zobacz ogłoszenie',
      myOffers: 'Moje ogłoszenia',
      goHome: 'Strona główna',
      nextSteps: {
        title: 'Co dalej?',
        description: 'Twoje ogłoszenie jest teraz aktywna i widoczna dla wszystkich użytkowników.'
      },
      error: {
        title: 'Błąd potwierdzenia płatności',
        retry: 'Spróbuj ponownie'
      },
      phoneModal: {
        title: 'Brak numeru telefonu',
        offerActivated: 'Twoja ogłoszenie zostało aktywowane pomyślnie!',
        description: 'Twoje ogłoszenie jest teraz aktywna i widoczna dla wszystkich użytkowników. Jednak zauważyliśmy, że nie masz dodanego numeru telefonu w swoim profilu.',
        phoneMissing: 'Dodanie numeru telefonu ułatwi potencjalnym kupującym kontakt z Tobą i zwiększy szanse na szybką sprzedaż.',
        addPhone: 'Dodaj numer telefonu'
      },
      // Nowe teksty dla strony sukcesu aktywacji
      sellFaster: 'Zwiększ szansę na szybką sprzedaż!',
      shareInSocialMedia: 'Udostępnij ogłoszenie w mediach społecznościowych',
      joinCommunity: 'Dołącz do naszej społeczności:',
      shareOnFacebook: 'Udostępnij na Facebooku',
      copyOfferLink: 'Kopiuj link do ogłoszenia',
      joinGroup: 'Dołącz do Gielda4x4 na Facebooku',
      viewYourOffer: 'Zobacz swoje ogłoszenie',
      showMyOffers: 'Wyświetl moje ogłoszenia',
      backToHomepage: 'Wróć na Stronę Główną',
      likeOurPortal: 'Podoba Ci się nasz portal? Możesz postawić nam wirtualną kawę. Dziękujemy!',
      linkCopied: 'Link skopiowany do schowka!',
      copyFailed: 'Nie udało się skopiować linku',
      increaseSalesChance: 'Chcesz zwiększyć szansę sprzedaży?',
      copyLinkTitle: 'Skopiuj link do ogłoszenia',
      findGroupAndShare: 'Znajdź odpowiednią grupę i udostępnij link',
      findGroupAndShareWithModel: 'Znajdź grupę {brandModel} na Facebooku i udostępnij link',
      findGroupAndShareButton: 'Znajdź grupę i udostępnij link',
      printAndPlaceTitle: 'Możesz też wydrukować stronę z ogłoszeniem i wstawić ją za szybę do samochodu',
      printPdf: 'Wydrukuj stronę z ogłoszeniem',
      generatingPdf: 'Generowanie PDF...',
      likeOurPortal: 'Podoba Ci się nasz portal? Możesz postawić nam wirtualną kawę. Dziękujemy!',
      buyCoffee: 'Postaw kawę',
      pdfDownloadError: 'Nie udało się pobrać PDF',
      // Teksty dla szczegółów oferty
      shareOffer: 'Udostępnij ogłoszenie',
      shareOnFacebook: 'Udostępnij na Facebooku',
      copyOfferLink: 'Kopiuj link',
      joinGroup: 'Dołącz do społeczności Gielda4x4'
    },
    cancel: {
      title: 'Płatność anulowana',
      description: 'Płatność została anulowana. Możesz spróbować ponownie lub wrócić do swoich ogłoszeń.',
      info: {
        title: 'Informacja',
        description: 'Nie zostały pobrane żadne opłaty. Możesz bezpiecznie spróbować ponownie.'
      },
      retryPayment: 'Spróbuj ponownie',
      myOffers: 'Moje ogłoszenia',
      goHome: 'Strona główna',
      support: {
        title: 'Potrzebujesz pomocy?',
        description: 'Jeśli masz problemy z płatnością, skontaktuj się z naszym zespołem wsparcia.'
      }
    }
  },
  payment: {
    title: 'Płatność',
    description: 'Wybierz metodę płatności i wprowadź wymagane dane, aby zakończyć płatność',
    summary: 'Podsumowanie płatności',
    paymentMethod: 'Metoda płatności',
    cardDetails: 'Dane karty',
    payNow: 'Zapłać teraz',
    processing: 'Przetwarzanie płatności...',
    loading: 'Ładowanie...',
    retry: 'Spróbuj ponownie',
    creditCard: 'Karta kredytowa/debetowa',
    creditCardDescription: 'Visa, Mastercard, American Express',
    blikDescription: 'Szybka płatność mobilna',
    googlePayDescription: 'Płatność przez Google Pay',
    applePayDescription: 'Płatność przez Apple Pay',
    blikCode: 'Kod BLIK',
    blikInstructions: 'Płatność przez BLIK',
    checkout: {
      info: 'Bezpieczna płatność',
      description: 'Zostaniesz przekierowany do bezpiecznej strony Stripe, gdzie możesz wybrać metodę płatności.',
      alternative: 'Lub otwórz w nowej karcie:',
      openInNewTab: 'Otwórz w nowej karcie'
    },
    security: {
      title: 'Bezpieczna płatność',
      description: 'Twoje dane są chronione przez szyfrowanie SSL. Nie przechowujemy informacji o kartach.'
    },
    success: {
      title: 'Płatność zakończona pomyślnie.',
      description: 'Twoje ogłoszenie zostało aktywowane. Możesz teraz przejść do szczegółów ogłoszenia.',
      continue: 'Przejdź do ogłoszenia'
    },
    modal: {
      title: 'Płatność'
    },
    offerNotActiveNoProduct: 'Nie można utworzyć sesji płatności: ogłoszenie nie jest aktywne i nie wybrano produktu ogłoszenia.'
  },
  sellerProfile: {
    title: 'Profil sprzedającego',
    verified: 'Zweryfikowany',
    company: 'Firma',
    aboutSeller: 'O sprzedającym',
    memberSince: 'Członek od',
    activeOffers: 'aktywnych ogłoszeń',
    sellerOffers: 'Ogłoszenia sprzedającego',
    noActiveOffers: 'Brak aktywnych ogłoszeń',
    noActiveOffersDescription: 'Ten sprzedający nie ma obecnie żadnych aktywnych ogłoszeń.',
    seeDetails: 'Zobacz szczegóły',
    added: 'Dodano:',
    honorBadge: 'Wyróżnione'
  },
  mainCategoryModal: {
    title: 'Wybierz główną kategorię',
    description: 'Wybierz kategorię, która najlepiej opisuje Twoje ogłoszenie',
    loading: 'Ładowanie kategorii...',
    errorTitle: 'Błąd ładowania',
    fetchError: 'Nie udało się załadować kategorii. Spróbuj ponownie.',
    retry: 'Spróbuj ponownie',
    instruction: 'Kliknij na jedną z kategorii powyżej, aby kontynuować dodawanie ogłoszenia.',
    cannotClose: 'Musisz wybrać kategorię, aby kontynuować',
    descriptions: {
      cars: 'Samochody terenowe, SUV, Pickup, wyprawowe',
      quads: 'Quady, ATV i inne pojazdy czterokołowe terenowe',
      accessories: 'Akcesoria offroad, wyposażenie terenowe i overlanding',
      parts: 'Części zamienne, elementy nadwozia i osprzęt',
      tires: 'Opony, felgi i akcesoria do kół',
      services: 'Usługi mechaniczne, tuning i serwis pojazdów',
      default: 'Wybierz tę kategorię dla swojego produktu'
    }
  },
  notFound: {
    title: 'Strona nie została znaleziona',
    subtitle: 'Przepraszamy, ale strona której szukasz nie istnieje.',
    description: 'Sprawdź nasze wyróżnione ogłoszenia poniżej lub skorzystaj z wyszukiwarki powyżej, aby znaleźć to czego szukasz.',
    backToHome: 'Wróć do strony głównej',
    viewAllOffers: 'Zobacz wszystkie ogłoszenia'
  },
  articles: {
    title: 'Artykuły',
    loading: 'Ładowanie artykułu...',
    notFound: 'Artykuł nie został znaleziony',
    notFoundDescription: 'Artykuł o podanym adresie nie istnieje lub został usunięty.',
    backToArticles: 'Powrót do artykułów',
    backToArticlesButton: 'Powrót do artykułów',
    category: 'Kategoria',
    publishedAt: 'Opublikowano',
    views: 'Wyświetlenia',
    featured: 'Wyróżniony',
    readMore: 'Czytaj więcej',
    relatedArticles: 'Powiązane artykuły',
    imageAlt: 'Zdjęcie artykułu',
    previousImage: 'Poprzednie zdjęcie',
    nextImage: 'Następne zdjęcie',
    photoGallery: 'Galeria zdjęć',
    list: {
      title: 'Artykuły i poradniki',
      subtitle: 'Dowiedz się jak kupić, sprzedać i dbać o swój pojazd. Sprawdzone poradniki od ekspertów branży motoryzacyjnej.',
      searchPlaceholder: 'Szukaj artykułów...',
      allCategories: 'Wszystkie kategorie',
      newest: 'Najnowsze',
      mostPopular: 'Najpopularniejsze',
      alphabetical: 'Alfabetycznie',
      featuredArticles: 'Wyróżnione artykuły',
      allArticles: 'Wszystkie artykuły',
      noArticles: 'Brak artykułów',
      noArticlesDescription: 'Nie znaleziono artykułów do wyświetlenia.',
      searchResults: 'Wyniki wyszukiwania dla "{query}"',
      categoryResults: 'Artykuły w kategorii "{category}"',
      loadMore: 'Załaduj więcej',
      loadingMore: 'Ładowanie...'
    },
    home: {
      featuredTitle: 'PORADNIKI I ARTYKUŁY',
      latestTitle: 'NAJNOWSZE ARTYKUŁY',
      description: 'Dowiedz się jak kupić, sprzedać i dbać o swój pojazd. Sprawdzone poradniki od ekspertów branży motoryzacyjnej.'
    }
  },
  partnership: {
    title: 'Współpraca',
    intro: 'Zapraszamy do współpracy! Oferujemy możliwości reklamowe i partnerstwo.',
    advertisement: {
      title: 'Reklamy',
      description: 'Banery w strategicznych miejscach na naszej platformie.'
    },
    partnership: {
      title: 'Partnerstwo',
      description: 'Kody na specjalne wyróżnienie i inne możliwości współpracy.'
    },
    contact: {
      title: 'Skontaktuj się z nami',
      description: 'Jesteś zainteresowany współpracą? Wypełnij formularz poniżej, a odpowiemy w ciągu 24 godzin.'
    },
    form: {
      name: 'Imię i nazwisko',
      namePlaceholder: 'Wprowadź swoje imię i nazwisko',
      email: 'Email',
      emailPlaceholder: 'Wprowadź swój adres email',
      company: 'Firma (opcjonalnie)',
      companyPlaceholder: 'Nazwa firmy',
      interest: 'Rodzaj współpracy',
      interestPlaceholder: 'Wybierz rodzaj współpracy',
      options: {
        advertisement: 'Reklamy',
        partnership: 'Partnerstwo',
        other: 'Inne'
      },
      message: 'Wiadomość',
      messagePlaceholder: 'Opisz szczegóły współpracy...',
      consent: 'Wyrażam zgodę na przetwarzanie moich danych osobowych przez operatora serwisu w celu kontaktu oraz realizacji mojego zapytania dotyczącego współpracy. Podanie danych jest dobrowolne, przyjmuję do wiadomości, że mam prawo dostępu do treści swoich danych oraz ich poprawiania, a także żądania ich usunięcia.',
      submit: 'Wyślij wiadomość',
      submitting: 'Wysyłanie...',
      successMessage: 'Dziękujemy za wiadomość! Odpowiemy w ciągu 24 godzin.',
      errorMessage: 'Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie.'
    },
    meta: {
      title: 'Współpraca - Gielda4x4',
      description: 'Zapraszamy do współpracy! Oferujemy reklamy i partnerstwo. Skontaktuj się z nami',
      keywords: 'współpraca, partnerstwo, reklama, marketing, gielda4x4, 4x4, pojazdy'
    }
  }
} 